import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { useTheme } from '../../ThemeContext';

import Modal from '../Modal';

import {
  Wrapper,
  Header,
  Title,
  Content,
  Footer,
  Grow,
  Button,
  ArrowButton,
  ArrowButtonIcon,
  WizardStepsCounter,
  Wizards,
  Wizard,
} from './AiTrainingAdd.style';

const AiTrainingAddInner = ({ handleClose = () => {} }) => {
  const theme = useTheme();
  const intl = useIntl();
  const [availableWizards] = useState(5);
  const [currentWizard, setCurrentWizard] = useState(1);

  const handleChangeCurrentWizard = (type) => {
    if (type === 'prev' && currentWizard > 0)
      setCurrentWizard(currentWizard - 1);
    else if (type === 'next' && currentWizard < availableWizards)
      setCurrentWizard(currentWizard + 1);
  };

  return (
    <Wrapper theme={theme.dataSourceAdd.wrapper}>
      <Header theme={theme.dataSourceAdd.header}>
        <Title theme={theme.dataSourceAdd.title}>
          {intl.formatMessage({
            id: 'ADD_AI_TRAINING.NEW_NEURAL_NETWORK_TRAINING_WIZARD',
          })}
        </Title>
        <WizardStepsCounter theme={theme.alTrainingAdd.wizardStepsCounter}>
          {currentWizard}/{availableWizards}
        </WizardStepsCounter>
      </Header>
      <Content>
        <Wizards>
          {currentWizard === 1 ? <Wizard></Wizard> : ''}
          {currentWizard === 2 ? <Wizard></Wizard> : ''}
          {currentWizard === 3 ? <Wizard></Wizard> : ''}
          {currentWizard === 4 ? <Wizard></Wizard> : ''}
          {currentWizard === 5 ? <Wizard></Wizard> : ''}
        </Wizards>
      </Content>
      <Footer>
        <ArrowButton
          theme={theme.button.default}
          disabled={!(currentWizard > 1) ? true : undefined}
          onClick={() => {
            handleChangeCurrentWizard('prev');
          }}
        >
          <ArrowButtonIcon className='material-icons'>
            arrow_back
          </ArrowButtonIcon>
        </ArrowButton>

        <Grow />
        <Button
          theme={theme.button.alt}
          onClick={() => {
            handleClose();
          }}
        >
          {intl.formatMessage({ id: 'ADD_AI_TRAINING.CANCEL' })}
        </Button>
        <Button theme={theme.button.default} disabled>
          {intl.formatMessage({ id: 'ADD_AI_TRAINING.SEND_FOR_TRAINING' })}
        </Button>
        <Grow />

        <ArrowButton
          theme={theme.button.default}
          disabled={!(currentWizard < availableWizards) ? true : undefined}
          onClick={() => {
            handleChangeCurrentWizard('next');
          }}
        >
          <ArrowButtonIcon className='material-icons'>
            arrow_forward
          </ArrowButtonIcon>
        </ArrowButton>
      </Footer>
    </Wrapper>
  );
};

const AiTrainingAdd = ({ handleClose = () => {} }) => {
  return (
    <Modal
      handleClose={() => {
        handleClose();
      }}
    >
      <AiTrainingAddInner
        handleClose={() => {
          handleClose();
        }}
      />
    </Modal>
  );
};

AiTrainingAddInner.propTypes = {
  handleClose: PropTypes.func,
};

AiTrainingAdd.propTypes = {
  handleClose: PropTypes.func,
};

export default AiTrainingAdd;
